"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregationIntervalHelperByValueTypeId = void 0;
const _aggregation_helpers_1 = require("../../_aggregation_helpers");
exports.aggregationIntervalHelperByValueTypeId = {
    signalTS5: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    trunkDisplacement: _aggregation_helpers_1.defaultAggregationIntervalHelper,
};
//# sourceMappingURL=plant_stress.js.map